import { AUTH_TYPES } from "../../actions/types";

const initState = {
  isAuthenticated: false,
  host: null,
  errorMessage: "",
};
const authReducer = (state = initState, action) => {
  switch (action.type) {
    case AUTH_TYPES.AUTH_SIGN_IN:
      return {
        ...state,
        host: action.payload,
        isAuthenticated: true,
        errorMessage: "",
      };
    case AUTH_TYPES.AUTH_SIGN_OUT:
      return {
        ...state,
        token: action.payload,
        isAuthenticated: false,
        errorMessage: "",
      };
    case AUTH_TYPES.AUTH_ERROR:
      return { ...state, errorMessage: action.payload };
    default:
      return state;
  }
};

export default authReducer;
